import { render, staticRenderFns } from "./ThirdPartySabaResultDialog.vue?vue&type=template&id=6ac3839e"
import script from "./ThirdPartySabaResultDialog.vue?vue&type=script&lang=js"
export * from "./ThirdPartySabaResultDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports